import { render, staticRenderFns } from "./LeadEmailsMenu.vue?vue&type=template&id=5bbc622e&"
import script from "./LeadEmailsMenu.vue?vue&type=script&lang=js&"
export * from "./LeadEmailsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports